module.exports = __webpack_public_path__ + "img/plano_saúde.95dc130f.svg";